module.exports = __webpack_public_path__ + "static/media/cardiff.b4581f87.png";